import {i18n} from "@/plugins/i18n";

export const sourceType = {
    PANEL: 1,
    WEBSERVICE: 2,
    SYSTEM: 3,
}

export const sourceTypeStr = {
    PANEL: i18n.t('application.source.panel'),
    WEBSERVICE: i18n.t('application.source.webservice'),
    SYSTEM: i18n.t('application.source.system'),

    get(provider) {
        let str = null;

        Object.keys(sourceType).forEach(item => {
            if (sourceType[item] === provider) {
                str = sourceTypeStr[item];
            }

        });

        return str || '-';
    }
}